import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Country", -1)

import singleSelect from "@/components/ui/dropdowns/single-select.vue";
import { onMounted, ref, inject, computed, PropType } from "vue";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { Country } from "@/types/generic/Country";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'country-select',
  props: {
  /**
   * The numeric value used with `v-model` to control the state of the component.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },
  /**
   * Indicates whether the component is read-only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * The width of the component, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
},
  emits: ["update:modelValue", "valueChanged"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "228fe37b": (props.width)
}))

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const dropdownDataSource = ref<Country[]>([]);

onMounted(async () => {
  try {
    dropdownDataSource.value =
      await acquaintApiClient.httpGet(`app/system/countries`);
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
});





const countryCode = computed({
  get: () => props.modelValue,
  set: (value: number) => emit("update:modelValue", value),
});

const valueChanged = (description: string) => {
  emit("valueChanged", description);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(singleSelect, {
      readOnly: props.readOnly,
      modelValue: countryCode.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((countryCode).value = $event)),
      dataSource: dropdownDataSource.value,
      onValueChanged: valueChanged,
      width: __props.width
    }, null, 8, ["readOnly", "modelValue", "dataSource", "width"])
  ]))
}
}

})